// Utils > Array
export function hasIntersection(a1: any[], a2: any[]): boolean {
	for (let i = 0, n = a1.length; i < n; i++) {
		const value = a1[i]

		if (a2.includes(value)) {
			return true
		}
	}

	return false
}

export function hasDifference(a1: any[], a2: any[]): boolean {
	for (let i = 0, n = a1.length; i < n; i++) {
		const value = a1[i]

		if (!a2.includes(value)) {
			return true
		}
	}

	return false
}

/**
 * shallow comparison of two arrays, returns the unique values
 */
export function difference(a1: any[], a2: any[]): Array<any> {
	const final = []

	for (let i = 0, n = a1.length; i < n; i++) {
		const v = a1[i]

		if (!a2.includes(v)) final.push(v)
	}

	return final
}

/**
 * can be passed to javascript's sort method to sort an array of numbers numerically
 * @param a 
 * @param b 
 */
export const sortNumerically = (a: number, b: number) => a - b

/**
 * takes the array and buckets the numbers less than and greater than the provided split number; is non-inclusive of split
 */
export function bucketLessAndGreaterThan(a: number[], split: number): [number[], number[]] {
	const lessThan: number[] = []
	const greaterThan: number[] = []

	for (let i = 0, n = a.length; i < n; i++) {
		const v = a[i]
		if (v < split) lessThan.push(v)
		else if (v > split) greaterThan.push(v)
	}

	return [lessThan.sort(sortNumerically), greaterThan.sort(sortNumerically)]
}

/**
 * returns index of first occurence where provided comparator is truthy; defaults comparator to strict equality check
 */
export function indexOf(arrayToCheck: any[], comparator: (arrayValue: any) => boolean | any) {
	const checkWith = typeof comparator === 'function' ? comparator : (arrayValue: any) => arrayValue === comparator

	let ix: number = -1
	for (let i = 0, n = arrayToCheck.length; i < n; i++) {
		const arrValue = arrayToCheck[i]

		if (checkWith(arrValue)) {
			ix = i
			break
		}
	}

	return ix
}
